import PropTypes from "prop-types";
import SoftBox from "components/SoftBox";

// Renders the route key in parentheses after the menu item's name,
// in a smaller font, so each sidebar entry has a stable reference id.
function RefKeyBadge({ refKey }) {
  if (!refKey) return null;
  return (
    <SoftBox
      component="span"
      sx={{
        fontFamily: "monospace",
        fontSize: 9,
        lineHeight: 1.4,
        ml: 0.5,
        opacity: 0.6,
        flexShrink: 0,
      }}
    >
      ({refKey})
    </SoftBox>
  );
}

RefKeyBadge.propTypes = {
  refKey: PropTypes.string,
};

export default RefKeyBadge;
